export class EvalError extends Error {
    constructor(position, message) {
        super(message);
        this.position = position;
        this.message = message;
    }
}
export class ParseError extends Error {
    constructor(position, reason) {
        super(reason === undefined ? 'parsing error' : `parsing error: ${reason}`);
        this.position = position;
        this.reason = reason;
    }
}
